// Central hotel-affiliate link for the whole site (destination guides, travel
// resources, future post pages). Our Booking.com affiliate was terminated and
// Agoda is off the table (it's Booking Holdings, the same owner). No general-
// hotel program is approved on Travelpayouts yet — Trip.com, Booking, Expedia,
// Hotels.com etc. are all traffic-gated as of June 2026. Until one is approved
// this returns null and callers render their hotel slots unlinked.
//
// To relight every hotel CTA sitewide, build the Travelpayouts deep link here
// (marker 444230) and return it from this one function. Example once a program
// (id `<PROGRAM_ID>`) is live:
//
//   return `https://tp.media/r?marker=444230&p=<PROGRAM_ID>&u=${encodeURIComponent(
//     `https://www.example.com/hotels?city=${city}`,
//   )}`;
//
// Hostelworld (budget) and Vrbo (apartments) stay wired directly where they
// already are — this helper is for the general "hotel" slot only.
// eslint-disable-next-line no-unused-vars
export function hotelLink(city) {
  return null;
}
